import { Component, OnInit } from '@angular/core';
import { LoanScheduleResponse } from 'app/model/loanschedule';
import { Router, ActivatedRoute } from '@angular/router';
import { CotizacionesService } from '../cotizaciones.service';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { MatDialog } from '@angular/material/dialog';
// import * as XLSX from 'xlsx';
// import { AssertNotNull } from '@angular/compiler';

@Component({
  selector: 'mifosx-schedule-dialog',
  templateUrl: './schedule-dialog.component.html',
  styleUrls: ['./schedule-dialog.component.scss']
})
export class ScheduleDialogComponent implements OnInit {

  loanSchedule: LoanScheduleResponse;
  requestData: any;
  showTokenFields: boolean;
  refreshingToken: boolean = false;

  isWaived: boolean = false;

  displayedColumns: any[] = [
    'period',
    'daysInPeriod',
    'fromDate',
    'dueDate',
    'obligationsMetOnDate',
    'complete',
    'principalDue',
    'principalLoanBalanceOutstanding',
    'interestOriginalDue',
    'feeChargesDue',
    'penaltyChargesDue',
    'totalDueForPeriod',
    'totalPaidForPeriod',
    'totalPaidInAdvanceForPeriod',
    'totalPaidLateForPeriod',
    'totalOutstandingForPeriod'
  ];

  headerColumns: any[] = [
    'periodinfo',
    'loanamountandbalance',
    'totalcostofloan',
    'installmenttotals',

  ];

  constructor(     
    private cotizacionesService: CotizacionesService,
    private matDialog: MatDialog,
    private dialogHelper: DialogHelper,
    private router: Router,
    private route: ActivatedRoute) { 
    }

  ngOnInit(): void {
    if(this.loanSchedule == undefined || this.loanSchedule == null){
      this.loanSchedule = history.state.message.response || '';
      this.requestData = history.state.message.request || '';
    }
   
  }

  installmentStyle(installment: any): string {
    if (installment.isAdditional) {
      return 'additional';
    }
    return '';
  }

  exportToExcel() {
    this.cotizacionesService.getPrintableQuote(this.loanSchedule.resourceId,this.requestData,"quote",'excel')
    .subscribe((data: Blob) => {
      const downloadLink = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = downloadLink;
      link.download = 'Abono_capital_'+this.loanSchedule.resourceId+'.xlsx';
      link.click();
    });
  }

  exportToPDF() {
    this.cotizacionesService.getPrintableQuote(this.loanSchedule.resourceId,this.requestData,"quote",'pdf').subscribe(data =>
      this.dialogHelper.showDialogNoCloseAction(data, this.matDialog));
  }

}
